import {on} from 'delegated-events'

function selectRepoItem(event: Event) {
  const item = event.target as HTMLInputElement
  const form = item.closest<HTMLElement>('.js-policy-repos-container')!.querySelector('.js-policy-repos-form')!
  const selectedRepoInput = createRepoInput(item)
  const existing = form.querySelector(`[value='${selectedRepoInput.value}']`)
  if (existing) {
    existing.replaceWith(selectedRepoInput)
  } else {
    form.append(selectedRepoInput)
  }
}

function createRepoInput(item: HTMLInputElement): HTMLInputElement {
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = item.checked ? 'enable[]' : 'disable[]'
  input.value = item.value

  return input
}

on('change', '.js-policy-repos-container .js-repository-item-checkbox', selectRepoItem)
